export type DndTransformLike = {
  x: number;
  y: number;
  scaleX?: number;
  scaleY?: number;
};

/** Inline replacement for @dnd-kit/utilities CSS.Transform.toString to avoid init order issues. */
export function dndTransformToCss(transform: DndTransformLike | null | undefined): string | undefined {
  if (!transform) return undefined;
  const { x = 0, y = 0, scaleX = 1, scaleY = 1 } = transform;
  return `translate3d(${x}px, ${y}px, 0) scaleX(${scaleX}) scaleY(${scaleY})`;
}
